import * as React from 'react';
import { secondsFormattedAsHoursAndMinutes } from 'utilities/time';
import { AnswerStatsSummary } from './types';
import cx from 'classnames';

export default function Summary(props: AnswerStatsSummary) {
  const paceClassname = props.paceAverage <= props.otherPaceAverage ? 'text-success' : 'text-danger';

  return (
    <div className="row">
      <div className="text-center col-sm-4">
        <h4>{props.showingStudentAnswers ? '' : 'Your'} Percent Correct</h4>
        <p>
          <strong className="big" id="correct_answer_percentage">
            {props.correctAnswerPercentage}
          </strong>
          <br />(<span id="correct_answer_count">{props.correctAnswerCount}</span> of{' '}
          <span id="answer_count">{props.answerCount}</span>)
        </p>
      </div>
      <div className="text-center col-sm-4">
        <h4>{props.showingStudentAnswers ? '' : 'Your'} Average Pace</h4>
        <p>
          <strong className={cx('big', paceClassname)} id="pace_average">
            {secondsFormattedAsHoursAndMinutes(props.paceAverage)}
          </strong>
          <br />(<span id="pace_total">{secondsFormattedAsHoursAndMinutes(props.paceTotal)}</span> total)
        </p>
      </div>
      <div className="text-center col-sm-4">
        <h4>Others&apos; Average Pace</h4>
        <p>
          <strong className="big" id="other_pace_average">
            {secondsFormattedAsHoursAndMinutes(props.otherPaceAverage)}
          </strong>
          <br />(<span id="other_pace_total">{secondsFormattedAsHoursAndMinutes(props.otherPaceTotal)}</span> total)
        </p>
      </div>
    </div>
  );
}
